import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { advPlatform, disableAdvPlatform, delPlatform } from "@/api/Administration/advertisement";
import addvertisingPlatform from "./components/addvertisingPlatform";
export default {
  name: "advertisingPlatform",
  components: {
    addvertisingPlatform: addvertisingPlatform
  },
  data: function data() {
    return {
      tableData: [],
      addvertisingPlatform: false,
      total: 0,
      page: 1,
      showing: false,
      sels: [],
      selsString: '',
      searchData: {
        page: 1,
        page_size: 10
      }
    };
  },
  created: function created() {
    this.getData(1);
  },
  computed: {},
  methods: {
    handleSource: function handleSource(id, num) {
      var _this = this;

      this.addvertisingPlatform = true;
      this.showing = true;
      this.$nextTick(function () {
        _this.$refs.addvertisingPlatform.init(id, num);
      });
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.getData(1);
    },
    getData: function getData(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.searchData.page = e;
                advPlatform(_this2.searchData).then(function (res) {
                  if (res.status == 200) {
                    if (!res.data.data.length && e > 1) {
                      _this2.getData(e - 1);
                    } else {
                      _this2.tableData = res.data.data || [];
                      _this2.total = res.data.total || 0;
                    }
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this3 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this3.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    handleDisable: function handleDisable(id) {
      var _this4 = this;

      disableAdvPlatform({
        id: id
      }).then(function (res) {
        if (res.status == 200) {
          Message({
            message: res.message,
            type: "success"
          });

          _this4.getData(_this4.searchData.page);
        }
      });
    },
    handleDelete: function handleDelete(id) {
      var _this5 = this;

      this.$confirm(this.$t('confirmDeleteData'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                delPlatform({
                  id: id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this5.getData(_this5.searchData.page);

                    _this5.$message({
                      type: "success",
                      message: _this5.$t('deleteSuccessExclamation')
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};